@if(supplierPromotion(); as supplierPromotion) {
  <div class="flex flex-col">
    <soft-promotion-card class="p-2 w-full" [promotion]="supplierPromotion.promotion"></soft-promotion-card>
    <span class="font-bold text-sm p-2 text-info">
      <soft-icon class="!inline mr-2" name="fa-regular fa-truck"></soft-icon>
      {{supplierPromotion.supplier.number}} - {{supplierPromotion.supplier.name}}
    </span>
  </div>
}
